import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { sectionHook } from '../../lib/domHooks';

/**
 * Zümrüt şemasının bölüm kabuğu: solda başlık, sağda "Daha Fazlası" bağlantısı
 * ve şeridi kaydıran ok çifti, altında yatay kayan kart şeridi.
 */
const ZumrutSection = ({ title, to, wide = false, section, children }) => {
  const stripRef = useRef(null);

  const scroll = (direction) => {
    const el = stripRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.max(el.clientWidth * 0.8, 240), behavior: 'smooth' });
  };

  return (
    <section {...sectionHook(section)}>
      <div className="zumrut-section-head">
        <h2 className="zumrut-section-title">{title}</h2>
        <div className="zumrut-section-nav">
          <button
            type="button"
            className="zumrut-section-arrow"
            onClick={() => scroll(-1)}
            aria-label="Önceki"
          >
            <ChevronLeft size={15} />
          </button>
          <button
            type="button"
            className="zumrut-section-arrow"
            onClick={() => scroll(1)}
            aria-label="Sonraki"
          >
            <ChevronRight size={15} />
          </button>
          {to && (
            <Link to={to} className="zumrut-section-more">
              Daha Fazlası <ChevronRight size={18} />
            </Link>
          )}
        </div>
      </div>
      <div className={`zumrut-strip ${wide ? 'is-wide' : ''}`} ref={stripRef}>
        {children}
      </div>
    </section>
  );
};

export default ZumrutSection;
